import React from 'react';

import { defaultSignatureFieldHeightPx, defaultSignatureFieldWidthPx } from '@aline/common';
import { useSelectCurrentUser } from 'src/gql';
import { useRefreshableFilestackImg } from 'src/helpers/integrations/filestack-download';
import type { ReactSetStateAction } from 'src/types';

interface DrawSignaturePreviewProps {
  isDrawSigEmpty: boolean;
  setDrawSigPreviewCanvas: ReactSetStateAction<HTMLCanvasElement | null>;
}

export function DrawSignaturePreview({
  isDrawSigEmpty,
  setDrawSigPreviewCanvas,
}: DrawSignaturePreviewProps): JSX.Element {
  const currentUser = useSelectCurrentUser();
  const { onError, src } = useRefreshableFilestackImg(currentUser?.settings.signatureImg);

  if (isDrawSigEmpty && src)
    return (
      <img
        alt="signature"
        height={defaultSignatureFieldHeightPx}
        src={src}
        width={defaultSignatureFieldWidthPx}
        onError={onError}
      />
    );

  return (
    <canvas
      ref={setDrawSigPreviewCanvas}
      height={defaultSignatureFieldHeightPx}
      width={defaultSignatureFieldWidthPx}
    />
  );
}
